export class ProductCode {
  public static Premium = ['PremiumA', 'PremiumB', 'PremiumC'];
  public static Free = ['FREEMIUM', 'FREEMEMBER'];

}
